import { ReactNode } from 'react';

import { Sport } from '__generated__/globalTypes';
import { ButtonBase } from 'atoms/buttons/ButtonBase';
import { useIsMobileApp } from 'hooks/useIsMobileApp';
import * as nativeMessages from 'protos/webview/channel/native_messages';
import { StringKeysOf } from 'types';

import { Item } from '../types';

type messages = StringKeysOf<nativeMessages.ChannelMessage>;

const getCollectionFromSport = (sport?: Sport) => {
  switch (sport) {
    case Sport.NBA:
      return nativeMessages.Collection.NBA;
    case Sport.FOOTBALL:
      return nativeMessages.Collection.FOOTBALL;
    case Sport.BASEBALL:
      return nativeMessages.Collection.BASEBALL;
    default:
      return nativeMessages.Collection.COLLECTION_UNKNOWN;
  }
};
const getItemPostMessage = (
  item: Item
): {
  message: messages;
  params: nativeMessages.ChannelMessage[messages];
} | null => {
  switch (item.__typename) {
    case 'BaseballCard':
    case 'NBACard':
    case 'Card': {
      return {
        message: 'showCardScreen',
        params: {
          cardSlug: item.slug,
          collection: getCollectionFromSport(item?.sport),
        },
      };
    }
    default: {
      return null;
    }
  }
};

type Props = {
  item: Item;
  children?: ReactNode;
};

export const IosOpenItemDialog = ({ item, children }: Props): ReactNode => {
  const { postMessage } = useIsMobileApp();
  const itemPostMessage = getItemPostMessage(item);

  if (!itemPostMessage) return children;

  const { message, params } = itemPostMessage;

  return (
    <ButtonBase
      onClick={() => {
        postMessage(message, params);
      }}
    >
      {children}
    </ButtonBase>
  );
};
